import { RouteBuilders } from "@simplyk/common";

import { UTM_SOURCE_PARAM_KEY } from "@/common/constants/params";
import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useUrlBuilder } from "@/common/hooks/useUrlBuilder";

export const useThemedFormZeffyLogoUrl = (utm: string) => {
  const { locale } = useLocaleContext();

  const urlBuilder = useUrlBuilder();

  return urlBuilder({
    route: RouteBuilders.homePageFreePlatformUrl({ locale }),
    searchParams: { [UTM_SOURCE_PARAM_KEY]: utm },
  });
};
